import { useMutation } from '@tanstack/react-query';
import { getActivityLogs } from '../../../services/logs';
import { useDispatch } from 'react-redux';
import { setActivityLog, setPage, setTake, setTotalCount } from '../../../redux/features/activityLog/activityLogSlice';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const useOnFilter = () => {
    const dispatch = useDispatch();
    const resetState = () => {
        dispatch(setPage(0));
        dispatch(setTake(20));
        dispatch(setTotalCount(0));
        dispatch(setActivityLog([]));
    }

    useEffect(() => {
        return () => { // state reset on unmount
            resetState();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function onSuccessFoo(data) {
        const { totalCount, activityLog } = data;
        dispatch(setTotalCount(totalCount));
        dispatch(setActivityLog(activityLog));
    }

    const activityMutation = useMutation({
        mutationKey: ["fetch-activity-log"],
        mutationFn: (filters) => getActivityLogs(filters),
        onSuccess: onSuccessFoo,
        onError: (error) => {
            resetState();
            toast.error("Error fetching activity logs:", error);
        },
        retry: 1,
    });

    return {
        onFilter: (filters) => {
            activityMutation.mutate(filters);
        },
        loading: activityMutation.isLoading,
        error: activityMutation.error,
    }
}

export default useOnFilter
